<ng-container [ngSwitch]="state$ | async">
    <div class="skeleton-rows" *ngSwitchCase="'loading'" aria-busy="true" aria-label="Carregando">
        <div class="skeleton-row" *ngFor="let row of rows" [style.grid-template-columns]="gridColumns">
            <span class="skeleton" *ngFor="let column of columns" [style.width.%]="cellWidth(row, column)"></span>
        </div>
    </div>

    <div class="empty-results" *ngSwitchCase="'empty'">
        <span class="empty-icon">
            <mat-icon>{{ icon }}</mat-icon>
        </span>
        <span class="empty-title">{{ heading }}</span>
        <span class="empty-message" *ngIf="message">{{ message }}</span>
    </div>
</ng-container>
